import api from "../../config/client.axios.api";

export const getTypeTransactionApi = async () => {
  const response = await api.get(`/type-transaction`);
  return response.data;
};
